export const OLD_BULK_BATCHES_THRESHOLD_IN_DAYS = 14;

export const BULK_BATCH_EVENT_HISTORY_START_DATE = "2025-03-10";

export const BULK_IMPORT_PAYABLES_NAMESPACE = "payables";
export const PAYABLES_SHEET_NAME = "Payables";
export const PAYABLES_SHEET_SLUG = PAYABLES_SHEET_NAME.toLowerCase();
export const PAYABLES_ACTION_SLUG = "finalizePayablesUpload";

export const BULK_IMPORT_CONTRACTORS_NAMESPACE = "contractors";
export const CONTRACTORS_SHEET_NAME = "Contractors";
export const CONTRACTORS_SHEET_SLUG = CONTRACTORS_SHEET_NAME.toLowerCase();
export const CONTRACTORS_ACTION_SLUG = "finalizeContractorsUpload";

/**
 * Batch label holding the number of rows the Flatfile listener could not upload.
 *
 * TODO: replace with `BATCH_LABELS_WS_KEYS.flatfileRejectedRowsCount` once
 * `@wingspanhq/payments` is bumped — the key was added around 4.208.4 and the app is
 * pinned to 4.143.2, which predates it.
 */
export const FLATFILE_REJECTED_ROWS_COUNT_LABEL_KEY =
  "flatfileRejectedRowsCount";

/** How often the Flatfile upload job is polled while an upload is in progress. */
export const FLATFILE_UPLOAD_JOB_REFETCH_INTERVAL = 5000;

// Rows the uploader stamped Rejected that Flatfile still counts as valid, so the error-state filter
// misses them. Kept to valid rows so nothing is counted twice.
export const FLATFILE_REJECTED_VALID_ROWS_FILTER = {
  filter: "valid",
  searchField: "uploadStatus",
  searchValue: "Rejected"
} as const;
